/* eslint-disable @typescript-eslint/no-explicit-any */
import { TableColumn } from '../../types';

import { SearchButton } from './Search';
import { FilterButton } from './Filter';
import { SortButton } from './Sort';

interface TableActionsProps {
  column: TableColumn<any>;
  index: number;
}

function TableActions({ column, index }: TableActionsProps): JSX.Element | null {
  const shouldRender = [column.sort, column.filter, column.search].some(Boolean);

  if (!shouldRender) return null;

  return (
    <>
      <span className="mr-1" />

      {column.search && <SearchButton column={column} index={index} />}

      {column.filter && <FilterButton column={column} index={index} />}

      {column.sort && <SortButton column={column} index={index} />}
    </>
  );
}

export default TableActions;
